const LOGO = require("Assets/Images/logo.svg").default;
const LOGO_WHITE = require("Assets/Images/logo-white.svg").default;
const IRAN_FLAG = require("Assets/Images/falg.png").default;

export { LOGO, LOGO_WHITE, IRAN_FLAG };
